<template>
  <main>
    <div class="container">
      <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

              <div class="d-flex justify-content-center py-4">
                <router-link to="/" class="logo d-flex align-items-center w-auto">
                  <img src="assets/img/logo.png" alt="">
                  <span class="d-none d-lg-block">FinPlan</span>
                </router-link>
              </div>

              <div class="card mb-3">

                <div class="card-body">

                  <div class="pt-4 pb-2">
                    <h5 class="card-title text-center pb-0 fs-4">Восстановление пароля</h5>
                    <p class="text-center small">Введите почту</p>
                  </div>

                  <form @submit.prevent="onSubmit" v-if="!sent" class="row g-3">

                    <div class="col-12">
                      <label for="email" class="form-label">Email</label>
                      <div class="input-group has-validation">
                        <input type="text" name="email" v-model="email" class="form-control" id="email" required>
                      </div>
                    </div>

                    <div v-if="error" class="invalid-feedback" style="display: block" v-html="error"></div>

                    <div class="col-12">
                      <button class="btn btn-primary w-100" :disabled="loading" type="submit">
                        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Подтвердить
                      </button>
                    </div>
                  </form>
                  <div v-if="sent" class="col-12">
                    <p class="small mb-0 text-success">
                      На вашу почту отправлена ссылка восстановления. <router-link to="/auth">Назад</router-link>
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
</template>

<script setup>
import {onMounted, ref} from "vue";
import { usePersonal } from '@/features/personal/composables/usePersonal';
const {
  sendEmailLink,
} = usePersonal();

const email = ref('');
const error = ref('');
const loading = ref(false);
const sent = ref(false);

onMounted(async () => {

});

const onSubmit = async () => {
  loading.value = true;
  await sendEmailLink(email.value)
  .then(() => {
    sent.value = true;
  })
  .catch((e) => {
    error.value = "Не удалось отправить";
    if (e?.code === 'user_not_found') {
      error.value = "Пользователя с таким email не найден";
    }
  })
  .finally(() => {
    loading.value = false;
  })
}
</script>
